import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'dialog-ag-grid-search',
	templateUrl: './dialog-ag-grid-search.component.html',
	styleUrls: ['./dialog-ag-grid-search.component.scss']
})
export class DialogAgGridSearchComponent implements OnInit {

	@ViewChild('btnAceptar') btnAceptar!: ElementRef;
	@ViewChild('btnCancelar') btnCancelar!: ElementRef;
	@ViewChild('elTxtBuscar') elTxtBuscar!: ElementRef;



	@Output() onSelectRow: EventEmitter<any> = new EventEmitter();

	@Input() rowData: Observable<any[]> = of([]);
	@Input() columnDefs: any[] = [];
	columnDefsActions: any[] = [];
	@Input() tittle = '';

	txtBuscar = new FormControl('');
	$subscriptiontxtBuscar: Subscription;



	/** BEGIN: Config Ag-Grid */
	@Input() rowSelection = 'single';

	// context = { componentParent: this };
	gridApi: any;
	gridColumnApi: any;
	rowDataSubscription!: Subscription;

	overlayNoRowsTemplate =
		`<span class="ag-overlay-loading-center border-0 bg-transparent shadow-none">
		No se encontraron registros...
		</span>`;
	overlayLoadingTemplate =
		`<span class="ag-overlay-loading-top d-flex align-items-center border-0 bg-white shadow p-4 text-info" style="height: 20px;">
		<img src="assets/media-demo/loading.gif" height="20" width="25" class="mr-2">
		<strong>Cargando registros</strong>
		</span>`;
	/** END: Config Ag-Grid */
	/** BEGIN: Pagination */

	@ViewChild('lbPageSize') elbPageSize!: ElementRef;
	@ViewChild('lbCurrentPage') elbCurrentPage!: ElementRef;
	@ViewChild('lbTotalPages') elbTotalPages!: ElementRef;

	@Input() pagination = true;
	@Input() paginationPageSize = 10;

	pageFound!: boolean;
	paginas: number[] = [];
	desde!: number;
	hasta!: number;
	/** END: Pagination */
	constructor(
		private dialogRef: MatDialogRef<DialogAgGridSearchComponent>,
		@Inject(MAT_DIALOG_DATA) data: any
	) {

		this.$subscriptiontxtBuscar = this.txtBuscar.valueChanges.pipe(
			debounceTime(350)
		).subscribe(data => {
			this.gridApi.forEachNodeAfterFilter((node: any) => node.setSelected(false))
			this.gridApi.setQuickFilter(data);
		});
	}

	ngOnInit() {
		this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
			event.stopPropagation();
			if (event.key === 'Escape') {
				this.closeDialog();
			}
		});
	}
	selectFirstSearch() {
		if (!this.gridApi) {
			return;
		}
		if (this.columnDefsActions.length === 1) {
			return;
		}
		let rowData = [];
		this.gridApi.forEachNode((node: any) => rowData.push(node.data));
		if (rowData.length === 0) {
			this.btnAceptar.nativeElement.focus();
		}
		// return rowData;
		this.gridApi.forEachNodeAfterFilter((node: any) => node.rowIndex ? 0 : node.setSelected(true))
		this.gridApi.setFocusedCell(0, this.columnDefsActions[1].field);

	}

	focusLastRow() {
		let lastIndex = -1;
		this.gridApi.forEachNodeAfterFilter((node: any) => {
			if (node.rowIndex > lastIndex) {
				lastIndex = node.rowIndex;
			}
		});
		if (lastIndex === -1) {
			return;
		}
		this.gridApi.setFocusedCell(lastIndex, this.columnDefsActions[1].field);
	}
	onCellKeyPress(e: any) {
		let keyPressed = e.event.key;
		console.log('Key Pressed = ' + keyPressed);
		if (keyPressed === 'Enter') {
			let rowNode = e.node;
			if (rowNode.selected) {
				this.btnAceptar.nativeElement.focus();
			} else {
				rowNode.setSelected(true);
			}
		}
	}
	guardar() {
		this.dialogRef.close(this.gridApi.getSelectedRows());
	}
	closeDialog() {
		this.dialogRef.close([]);
	}
	/** BEGIN: Events Config Ag-Grid */
	onGridReady(params: any) {
		this.columnDefsActions = this.columnDefs.concat([
			{
				headerName: '',
				field: '',
				width: 40,
				minWidth: 40,
				maxWidth: 40,
				checkboxSelection(params: any) {
					return params.columnApi.getRowGroupColumns().length === 0;
				},
				pinned: 'left',
				sortable: false,
				lockPosition: true
			}
		]);

		console.log(this.columnDefs);
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.initRowData();
	}
	/** END: Events Config Ag-Grid */
	/** BEGIN: Events de desplazamiento en ag-grid */
	onPaginationChanged() {
		if (!this.gridApi) {
			return;
		}
		if (this.pagination && this.gridApi.paginationGetRowCount() > -1) {
			this.elbPageSize.nativeElement.innerHTML = this.gridApi.paginationGetRowCount();
			this.elbCurrentPage.nativeElement.innerHTML = this.gridApi.paginationGetCurrentPage() + 1;
			this.elbTotalPages.nativeElement.innerHTML = this.gridApi.paginationGetTotalPages();
			// this.elbtLast.nativeElement.setAttribute('disabled', !this.gridApi.paginationIsLastPageFound());
			this.pageFound = this.gridApi.paginationGetTotalPages() < 1;
			this.desde = Math.min(Math.max(1, this.gridApi.paginationGetCurrentPage() - 2), this.gridApi.paginationGetTotalPages() - 2);
			this.hasta = Math.max(Math.min(this.gridApi.paginationGetTotalPages(), this.gridApi.paginationGetCurrentPage() + 2), 5);
			if (this.gridApi.paginationGetTotalPages() > 5) {
				this.paginas = new Array(this.hasta - this.desde + 1).fill(0).map((valor, indice) => indice + this.desde);
			} else {
				this.paginas = new Array(this.gridApi.paginationGetTotalPages()).fill(0).map((valor, indice) => indice + 1);
			}

		}
	}
	onBtFirst() {
		this.gridApi.paginationGoToFirstPage();
		this.autoSizeColumns();
	}
	onBtPrevious() {
		this.gridApi.paginationGoToPreviousPage();
		this.autoSizeColumns();
	}
	onBtNext() {
		this.gridApi.paginationGoToNextPage();
		this.autoSizeColumns();
	}
	onBtLast() {
		this.gridApi.paginationGoToLastPage();
		this.autoSizeColumns();
	}

	onPageSizeChanged(evt: any) {
		this.gridApi.paginationSetPageSize(Number(evt.target.value));
	}
	onGoToPage(page: any) {
		this.gridApi.paginationGoToPage(page);
	}

	/** END: Events de desplazamiento en ag-grid */
	/** BEGIN: UTILS  */
	initRowData() {
		if (this.rowDataSubscription) {
			this.rowDataSubscription.unsubscribe();
			this.gridApi.setRowData([]);
			this.gridApi.showLoadingOverlay();
		}
		this.rowDataSubscription = this.rowData.subscribe((data) => {
			this.gridApi.setRowData(data);

			if (this.columnDefs.length === 0 && data.length > 0) {
				let columnDefs: any = [];
				let keys = Object.keys(data[0]);
				keys.forEach(element => {
					if (typeof data[0][element] !== 'object') {
						columnDefs.push({ field: element, headerName: element.toUpperCase() });
					}
				});
				this.columnDefsActions = columnDefs.concat([
					{
						headerName: '',
						field: '',
						width: 40,
						minWidth: 40,
						maxWidth: 40,
						checkboxSelection(params: any) {
							return params.columnApi.getRowGroupColumns().length === 0;
						},
						pinned: 'left',
						sortable: false,
						lockPosition: true
					}
				]);
			}

			this.gridApi.sizeColumnsToFit();
			const colIds = this.gridColumnApi
				.getAllDisplayedColumns()
				.map((col: any) => col.getColId());
			this.gridColumnApi.autoSizeColumns(colIds);
		});
	}
	autoSizeColumns() {
		const colIds = this.gridColumnApi
			.getAllDisplayedColumns()
			.map((col: any) => col.getColId());
		this.gridColumnApi.autoSizeColumns(colIds);
	}
	/** END: UTILS  */
}
